module.exports = __webpack_public_path__ + "img/logo.12afe4d2.png";